<template>
  <router-view />
</template>

<script setup lang="ts">
import { useBase } from "@/composables/useBase";
import { useRequiredAuth } from "@/composables/useRequiredAuth";
import { useExceptionStore } from "@/stores/exceptionStore";
import { useDevice } from "src/composables/useDevice";
import { useAuthenStore } from "@/stores/authenStore";
import { onBeforeUnmount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useLang } from "./composables/useLang";
import { useTheme } from "./composables/useTheme";
import { usePreFetch } from "./composables/usePreFetch";
import { useAppStore } from "./stores/appStore";
import { useCategoryStore } from "./stores/categoryStore";
// import { useCart } from "./composables/useCart";
// import { useCartStore } from "./stores/cartStore";

const { appNavigateTo } = useBase();
const exceptionStore = useExceptionStore();
const router = useRouter();
const authenStore = useAuthenStore();
const { initialDevice } = useDevice();
// const { userCart } = useCart();

defineOptions({
  async preFetch({ ssrContext, redirect, store }) {
    const { callAxios } = usePreFetch(ssrContext, redirect);
    // const cartStore = useCartStore();
    const appStore = useAppStore(store);
    const categoryStore = useCategoryStore(store);

    try {
      const [categories, configuration] = await Promise.all([
        callAxios<any>({
          API: `/api/v1/categories`,
          method: "GET"
        }),
        callAxios<any>({
          API: `/api/v1/fee/configuration`,
          method: "GET"
        })
      ]);
      if (categories?.data) {
        categoryStore.setCategories(categories.data);
      }
      appStore.setInitialDataLoaded(true);

      // const configuration = await callAxios<any>({
      //   API: `/api/v1/fee/configuration`,
      //   method: "GET"
      // });
      if (configuration?.data) {
        appStore.setFeeConfiguration(configuration?.data);
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
      appStore.setInitialDataLoaded(true);
    }
  }
});

useRequiredAuth();

onMounted(async () => {
  const { initialQuasarDark } = useTheme();
  const { initialLocale } = useLang();
  // await userCart();
  initialQuasarDark();
  initialLocale();
  initialDevice();

  if (
    exceptionStore.error &&
    exceptionStore.error.statusCode &&
    exceptionStore.error.message
  ) {
    appNavigateTo("/error", true);
  }
  window.onpopstate = () => {
    if (
      router.options.history.state.forward == "/auth/login" &&
      !authenStore.auth
    ) {
      window.history.forward();
    }
  };
  // await useAuth().checkLoginStatus();
});

onBeforeUnmount(() => {});
</script>
